import { motion } from 'motion/react';

const ease = [0.22, 1, 0.36, 1];

const offsets = {
    up: { y: 40, x: 0 },
    down: { y: -24, x: 0 },
    left: { x: 40, y: 0 },
    right: { x: -40, y: 0 },
    none: { x: 0, y: 0 },
};

const AnimatedSection = ({
    as = 'section',
    children,
    className,
    delay = 0,
    direction = 'up',
    amount = 0.15,
    ...props
}) => {
    const offset = offsets[direction] || offsets.up;
    const Component = motion[as] || motion.section;

    return (
        <Component
            className={className}
            initial={{ opacity: 0, ...offset }}
            whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true, amount }}
            transition={{ duration: 1.25, ease, delay }}
            {...props}
        >
            {children}
        </Component>
    );
};

export const AnimatedGroup = ({
    as = 'div',
    children,
    className,
    stagger = 0.2,
    amount = 0.12,
    ...props
}) => {
    const Component = motion[as] || motion.div;

    return (
        <Component
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount }}
            variants={{
                hidden: {},
                visible: {
                    transition: { staggerChildren: stagger },
                },
            }}
            {...props}
        >
            {children}
        </Component>
    );
};

export const AnimatedItem = ({ as = 'div', children, className, ...props }) => {
    const Component = motion[as] || motion.div;

    return (
        <Component
            className={className}
            variants={{
                hidden: { opacity: 0, y: 28 },
                visible: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 1.05, ease },
                },
            }}
            {...props}
        >
            {children}
        </Component>
    );
};

export default AnimatedSection;
